import React from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { Flex, Icon, IconButton, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';

const InputLabel = ({ labelName, required = false, toolTip = '', width = '100%' }) => (
  <Flex
    flexFlow="row noWrap"
    justifyContent="space-between"
    mb={2}
    width={width}
  >
    <Flex alignItems="center" flexFlow="row nowrap">
      <Text color={colors.greyScale['600']} textStyle="bodySm500">{labelName}</Text>
      {toolTip && (
      <Tooltip hasArrow borderRadius="md" label={toolTip} placement="top">
        <IconButton
          boxSize={1}
          color={colors.greyScale['500']}
          icon={<Icon as={BsInfoCircle} />}
          variant="textGrey"
        />
      </Tooltip>
      )}
    </Flex>
    <Text color={colors.primaryScale['600']} textStyle="bodySm500">{required ? 'Required' : ''}</Text>
  </Flex>
);

InputLabel.propTypes = {
  labelName: PropTypes.string,
  toolTip: PropTypes.string,
  required: PropTypes.bool
};

export default InputLabel;
